// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"450":"CheckoutAlrajhi","456":"Success","910":"CheckoutAamaly"}[chunkId] + "." + {"450":"e47f0ebb","456":"ab81db46","910":"124b309f"}[chunkId] + ".css";
};